import api from '@services/api.service'
import { createAsyncThunk } from '@reduxjs/toolkit'

const sectionEndpoint = 'section/'

export const fetchAllSections = createAsyncThunk(
  'section/fetchAll',
  async () => {
    const response = await api.get(`${sectionEndpoint}`)

    if (response.status !== 200) {
      throw new Error('Error during login')
    }
    return {
      sections: response.data.map(
        (section: { name: string; updatedBy: string; updatedAt: 'string' }) =>
          section.name
      ),
    }
  }
)
